import type { TypedDocumentNode } from '@urql/core';

import { gql } from '@/shared/types/gql';

import type {
  CancelConnectMutation,
  CancelConnectVars,
  ConnectIntentMutation,
  ConnectIntentVars,
} from '../types';

/**
 * Begins a Connect (status CONNECTING) and returns the absolute `/api/integrations/start` URL the
 * sign-in tab is pointed at. Needs the `__Host-crm-connect` cookie (`markBrowser`). Never Teams'
 * channel step: `channels: false`.
 */
export const CONNECT_INTENT: TypedDocumentNode<ConnectIntentMutation, ConnectIntentVars> = gql`
  mutation ConnectIntent($service: IntegrationService!) {
    investbanq {
      integrations {
        connectIntent(input: { service: $service, channels: false }) {
          status
          url
        }
      }
    }
  }
`;

/** Returns the service's row to not connected (`cancelled`); the binding stays. Idempotent. */
export const CANCEL_CONNECT: TypedDocumentNode<CancelConnectMutation, CancelConnectVars> = gql`
  mutation CancelConnect($service: IntegrationService!) {
    investbanq {
      integrations {
        cancelConnect(service: $service) {
          status
        }
      }
    }
  }
`;
